// TODO: Turn this off later
import * as ActionCable from "@rails/actioncable"
import { createConsumer } from "@rails/actioncable"
import { notification, Alert } from "antd"

import store from "../stores/store"
import { setAlerts } from "../features/nav/alertPanelSlice"
import { updateGeneratedReportFile } from "../features/reports/reportsSlice"
import { updateUploadFile, updateInvoicePdf, updateBillImagesZip } from "../features/financials/accountingBatches/accountingBatchesSlice"
import { updateBatchUploadFile, updateBatchInvoicePdf, updateBatchBillImagesZip, quickbooksFileUpdated } from "../features/clientBatching/clientBatchingSlice"
import { updateDocument } from "../features/billDocumentRepositories/billDocumentRepositoriesSlice"
import { setAccountAlert } from "../features/billableAccounts/billableAccountsSlice"
import { modifyAlert } from "../features/billableAccounts/billableAccountNotesSlice"
import { modifySupplyAlert } from "../features/supplyAccounts/supplyAccountNotesSlice"

// ActionCable.logger.enabled = true

const URL = process.env.REACT_APP_CABLE_URL
const consumer = createConsumer(URL)

export const processCableResponse = (data) => {
    let msgDuration = 0.4

    if (data.error) {
        msgDuration = 0
    }

    if (data.notification_type) {
        notification[`${data.notification_type}`]({
            message: data.message,
            description: data.description ? data.description.join(", ") : "",
            duration: msgDuration,
        })
    } else {
        notification.open({
            message: data.message,
            description: data.description ? data.description.join(", ") : "",
            duration: msgDuration,
            duration: 0.8,
        })
    }

    if (data.link) {
        store.dispatch(setAlerts(data))
    }

    // dispatchers for specific data updates
    if (data.type === "generated_report") {
        store.dispatch(updateGeneratedReportFile(data))
    } else if (data.type === "accounting_batch_upload_file") {
        store.dispatch(updateUploadFile(data))
        // The same broadcast fills in the Finalize result screen, which lists the batches a client
        // batching run just created. Harmless when that screen is not open.
        store.dispatch(updateBatchUploadFile(data))
    } else if (data.type === "accounting_batch_invoice_pdf") {
        // The stored invoice PDF: fills in the Client Batches table and the Finalize result screen.
        // The toast and bell link above still come from the generic handling.
        store.dispatch(updateInvoicePdf(data))
        store.dispatch(updateBatchInvoicePdf(data))
    } else if (data.type === "accounting_batch_bill_images_zip") {
        // The bill images zip: Client Batches table and Finalize result. Broadcast with `zip_url`,
        // not `link`, so it does not land in the bell.
        store.dispatch(updateBillImagesZip(data))
        store.dispatch(updateBatchBillImagesZip(data))
    } else if (data.type === "client_batch_quickbooks_file") {
        // The QuickBooks daily file: fills in the Today's Runs card and the Finalize result screen.
        store.dispatch(quickbooksFileUpdated(data))
    } else if (data.type === "bill_documents") {
        store.dispatch(updateDocument(data))
    }
}

export const processBillableAccountNoteResponse = (data) => {
    store.dispatch(modifyAlert(data))
}

export const processSupplyAccountNoteResponse = (data) => {
    store.dispatch(modifySupplyAlert(data))
}

export default consumer
